module.exports = __webpack_public_path__ + "img/pay.02292733.svg";